import React, { useState } from 'react';
import './ExpertiseSection3.css';

const expertiseData3 = [
  {
    title: "Job Seekers",
    image: "https://img.freepik.com/free-photo/job-seekers-career-fair_23-2150386147.jpg",
    description: "Helping individuals find the right IT and Non-IT opportunities.",
    details: [
      "Freshers & Students",
      "Experienced Professionals",
      "Remote & On-site Jobs",
      "Part-time & Full-time Roles"
    ],
  },
  {
    title: "Freelancers",
    image: "https://img.freepik.com/free-photo/freelancer-working-laptop-home_23-2148787912.jpg",
    description: "Empowering freelancers with projects and flexible work opportunities.",
    details: [
      "Global Projects",
      "Skill-based Opportunities",
      "Work From Anywhere",
      "Timely Payouts"
    ],
  },
  {
    title: "Recruiters",
    image: "https://img.freepik.com/free-photo/recruitment-hr-team-interview_23-2150386144.jpg",
    description: "Connecting recruiters with the best talent.",
    details: [
      "Access to Skilled Candidates",
      "Faster Hiring Process",
      "Talent Matching",
      "End-to-End Hiring Support"
    ],
  },
  {
    title: "Career Guidance",
    image: "https://img.freepik.com/free-photo/hr-consulting-business-meeting_23-2149381243.jpg",
    description: "Providing mentorship and professional growth strategies.",
    details: [
      "Resume Building",
      "Mock Interviews",
      "Skill Development",
      "Counseling Sessions"
    ],
  },
];

const ExpertiseSection3 = () => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 4;

  const prevSlide = () => {
    setStartIndex((prev) =>
      prev === 0 ? Math.max(0, expertiseData3.length - visibleCount) : prev - 1
    );
  };

  const nextSlide = () => {
    setStartIndex((prev) =>
      prev + visibleCount >= expertiseData3.length ? 0 : prev + 1
    );
  };

  const visibleItems = expertiseData3.slice(startIndex, startIndex + visibleCount);

  return (
    <div
      className="expertise3-wrapper"
      style={{
        backgroundImage: `url('https://img.freepik.com/free-photo/business-team-working-project_23-2150386152.jpg')`,
      }}
    >
      <div className="expertise3-content">
        <div className="expertise3-header">
          <h2 className="expertise3-heading">
            Our <span>Expertise</span>
          </h2>
          <div className="expertise3-carousel-controls">
            <button onClick={prevSlide}>&#8592;</button>
            <button onClick={nextSlide}>&#8594;</button>
          </div>
        </div>

        <div className="expertise3-carousel">
          {visibleItems.map((item, index) => (
            <div className="expertise3-card" key={startIndex + index}>
              <img src={item.image} alt={item.title} />
              <div className="expertise3-overlay">
                <h3 className="expertise3-overlay-title">{item.title}</h3>
                <div className="expertise3-details">
                  <p className="expertise3-description">{item.description}</p>
                  <ul>
                    {item.details.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                  <button className="expertise3-learn-more">Learn more →</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExpertiseSection3;
